import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getPageSize } from '../../../../../utils'

// components
import FundListComponent from './list/list.component'

/**
 * Contact Managed Funds Container
 */
class ContactManagedFunds extends Component {

  /**
   * Constructor
   * @param props
   */
  constructor (props) {
    super(props)
    this.state = {
      filters: {
        limit: getPageSize('contact-fund-list') || 10,
        page: 1
      }
    }
  }

  /**
   * Get contact notes based on provided filters
   * @param filters
   */
  handleFilterChange = (filters) => {
    this.setState({
      filters: { ...this.state.filters, ...filters }
    })
  }

  /**
   * Render Notes
   * @returns {*}
   */
  render () {
    const { data } = this.props
    const { filters } = this.state

    const total = data && data.length ? data.length : 0

    return (
      <FundListComponent
        data={data}
        total={total}
        filters={filters}
        handleFilterChange={this.handleFilterChange} />
    )
  }
}

ContactManagedFunds.propTypes = {
  data: PropTypes.array.isRequired
}

export default ContactManagedFunds